import React from 'react';
import classes from './InivtesData.module.scss';
import { useTranslation } from 'react-i18next';
import RowLoader from 'components/Sceletons/RowLoader';
import cn from 'classnames';
import { CheckSquareOutlined, EditOutlined, HomeOutlined, LinkOutlined, SendOutlined } from '@ant-design/icons';
import { useAppSelector } from 'store/hook';
import { IInvitesInfo, invitesInfoDefault } from 'interfaces/AnalyticTypes';
import analytics from 'api/analytics';

type InivtesDataProps = {
  period: [string, string, string];
  choosenRoom?: string;
};

const InivtesData = ({choosenRoom, period}: InivtesDataProps) => {
  const [isLoadingInivtesData, setIsLoadingInivtesData] = React.useState(false);
  const [invitesInfo, setInvitesInfo] = React.useState<IInvitesInfo>(invitesInfoDefault);

  const { messageApi } = useAppSelector((state) => state.windowState);
  const { t } = useTranslation();
  
  const getInvitesInfo = async (period: [string, string, string], room?: string) => {
    setIsLoadingInivtesData(true);
    try {
      const invitesInfo = await analytics.getAnalyticsInvites({room, from: period[0], to: period[1]});  
      setInvitesInfo(invitesInfo.data);
    } catch (e) {
      messageApi?.error(t('Analytics.errors.invites'))
    } finally {
      setIsLoadingInivtesData(false);
    };
  };  

  React.useEffect(() => {
    getInvitesInfo(period, choosenRoom);
  }, [choosenRoom, period[2]]);

  return (
    <div className={cn(classes.section, classes.invites)}>
      <div className={classes.title}>{t('Analytics.section.invites')}</div>
      <div className={classes.contentInvites}>
        <div className={cn(classes.inviteCard, classes.create_line)}>
          <div className={classes.iconWrap}>
            <SendOutlined style={{paddingLeft: 4}} className={classes.cardIcon}/>
          </div>
          <div>
            <div className={classes.cardTitle}>{t('Analytics.invites.sended')}</div>
            {isLoadingInivtesData
              ? <div className={classes.cardPersons}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardPersons}>{invitesInfo?.sended} {t('Analytics.invites.peoples')}</div>
            }
            <div className={classes.cardInfo}>{t('Analytics.invites.start_point')}</div>
          </div>
        </div>
        <div className={cn(classes.inviteCard, classes.create_line)}>
          <div className={classes.iconWrap}>
            <LinkOutlined className={classes.cardIcon}/>
          </div>
          <div>
            <div className={classes.cardTitle}>{t('Analytics.invites.moved_to_registration')}</div>
            {isLoadingInivtesData
              ? <div className={classes.cardPersons}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardPersons}>{invitesInfo?.moved_to_registration} {t('Analytics.invites.peoples')}</div>
            }
            {isLoadingInivtesData
              ? <div className={classes.cardInfo}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardInfo}>
                {invitesInfo?.sended ? (invitesInfo?.moved_to_registration / invitesInfo?.sended * 100)?.toFixed(0) : 0}%
              </div>
            }
          </div>
        </div>
        <div className={cn(classes.inviteCard, classes.create_line)}>
          <div className={classes.iconWrap}>
            <EditOutlined className={classes.cardIcon}/>
          </div>
          <div>
            <div className={classes.cardTitle}>{t('Analytics.invites.filled_the_details')}</div>
            {isLoadingInivtesData
              ? <div className={classes.cardPersons}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardPersons}>{invitesInfo?.filled_the_details} {t('Analytics.invites.peoples')}</div>
            }
            {isLoadingInivtesData
              ? <div className={classes.cardInfo}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardInfo}>
                {invitesInfo?.sended ? (invitesInfo?.filled_the_details / invitesInfo?.sended * 100)?.toFixed(0) : 0}%
              </div>
            }
          </div>
        </div>
        <div className={cn(classes.inviteCard, classes.create_line)}>
          <div className={classes.iconWrap}>
            <CheckSquareOutlined className={classes.cardIcon}/>
          </div>
          <div>
            <div className={classes.cardTitle}>{t('Analytics.invites.registered')}</div>
            {isLoadingInivtesData
              ? <div className={classes.cardPersons}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardPersons}>{invitesInfo?.registered} {t('Analytics.invites.peoples')}</div>
            }
            {isLoadingInivtesData
              ? <div className={classes.cardInfo}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardInfo}>
                {invitesInfo?.sended ? (invitesInfo?.registered / invitesInfo?.sended * 100)?.toFixed(0) : 0}%
              </div>
            }
          </div>
        </div>
        <div className={classes.inviteCard}>
          <div className={classes.iconWrap}>
            <HomeOutlined className={classes.cardIcon}/>
          </div>
          <div>
            <div className={classes.cardTitle}>{t('Analytics.invites.entered_room')}</div>
            {isLoadingInivtesData
              ? <div className={classes.cardPersons}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardPersons}>{invitesInfo?.entered_room} {t('Analytics.invites.peoples')}</div>
            }
            {isLoadingInivtesData
              ? <div className={classes.cardInfo}><RowLoader height={20} width={60} padding={'0 0 0 0'}/></div>
              : <div className={classes.cardInfo}>
                {invitesInfo?.sended ? (invitesInfo?.entered_room / invitesInfo?.sended * 100)?.toFixed(0) : 0}%
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default InivtesData;
